import { render, staticRenderFns } from "./ZoneView.vue?vue&type=template&id=1c191094&scoped=true&"
import script from "./ZoneView.vue?vue&type=script&lang=js&"
export * from "./ZoneView.vue?vue&type=script&lang=js&"
import style0 from "./ZoneView.vue?vue&type=style&index=0&id=1c191094&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c191094",
  null
  
)

export default component.exports